/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './patient-organism-antibiotic-susceptibility.reducer';

export const PatientOrganismAntibioticSusceptibility = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const patientOrganismAntibioticSusceptibilityList = useAppSelector(state => state.patientOrganismAntibioticSusceptibility.entities);
  const loading = useAppSelector(state => state.patientOrganismAntibioticSusceptibility.loading);
  const totalItems = useAppSelector(state => state.patientOrganismAntibioticSusceptibility.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="patient-organism-antibiotic-susceptibility-heading" data-cy="PatientOrganismAntibioticSusceptibilityHeading">
        <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.home.title">
          Patient Organism Antibiotic Susceptibilities
        </Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/patient-organism-antibiotic-susceptibility/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.home.createLabel">
              Create new Patient Organism Antibiotic Susceptibility
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.patientOrganismAntibioticSusceptibility.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {patientOrganismAntibioticSusceptibilityList && patientOrganismAntibioticSusceptibilityList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('zoneOfInhibition')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.zoneOfInhibition">
                    Zone Of Inhibition
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('zoneOfInhibition')} />
                </th>
                <th className="hand" onClick={sort('mic')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.mic">Mic</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mic')} />
                </th>
                <th className="hand" onClick={sort('mbc')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.mbc">Mbc</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mbc')} />
                </th>
                <th className="hand" onClick={sort('testDate')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.testDate">Test Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('testDate')} />
                </th>
                <th className="hand" onClick={sort('virulenceFactors')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.virulenceFactors">
                    Virulence Factors
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('virulenceFactors')} />
                </th>
                <th className="hand" onClick={sort('resistanceMechanisms')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.resistanceMechanisms">
                    Resistance Mechanisms
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('resistanceMechanisms')} />
                </th>
                <th className="hand" onClick={sort('morphology')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.morphology">Morphology</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('morphology')} />
                </th>
                <th className="hand" onClick={sort('growthConditions')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.growthConditions">
                    Growth Conditions
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('growthConditions')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.timestampEntry">
                    Timestamp Entry
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('recommended')}>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.recommended">Recommended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recommended')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.patientLabTestItem">
                    Patient Lab Test Item
                  </Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.organism">Organism</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.antibiotic">Antibiotic</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.sensitivity">Sensitivity</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {patientOrganismAntibioticSusceptibilityList.map((patientOrganismAntibioticSusceptibility, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button
                      tag={Link}
                      to={`/patient-organism-antibiotic-susceptibility/${patientOrganismAntibioticSusceptibility.id}`}
                      color="link"
                      size="sm"
                    >
                      {patientOrganismAntibioticSusceptibility.id}
                    </Button>
                  </td>
                  <td>{patientOrganismAntibioticSusceptibility.zoneOfInhibition}</td>
                  <td>{patientOrganismAntibioticSusceptibility.mic}</td>
                  <td>{patientOrganismAntibioticSusceptibility.mbc}</td>
                  <td>{patientOrganismAntibioticSusceptibility.testDate}</td>
                  <td>{patientOrganismAntibioticSusceptibility.virulenceFactors}</td>
                  <td>{patientOrganismAntibioticSusceptibility.resistanceMechanisms}</td>
                  <td>{patientOrganismAntibioticSusceptibility.morphology}</td>
                  <td>{patientOrganismAntibioticSusceptibility.growthConditions}</td>
                  <td>{patientOrganismAntibioticSusceptibility.notes}</td>
                  <td>{patientOrganismAntibioticSusceptibility.active ? 'true' : 'false'}</td>
                  <td>{patientOrganismAntibioticSusceptibility.cursor}</td>
                  <td>{patientOrganismAntibioticSusceptibility.lastUpdated}</td>
                  <td>{patientOrganismAntibioticSusceptibility.microSec}</td>
                  <td>{patientOrganismAntibioticSusceptibility.timestampEntry}</td>
                  <td>{patientOrganismAntibioticSusceptibility.recommended ? 'true' : 'false'}</td>
                  <td>
                    {patientOrganismAntibioticSusceptibility.patientLabTestItem ? (
                      <Link to={`/user-lab-test-item/${patientOrganismAntibioticSusceptibility.patientLabTestItem.id}`}>
                        {patientOrganismAntibioticSusceptibility.patientLabTestItem.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {patientOrganismAntibioticSusceptibility.organism ? (
                      <Link to={`/organism/${patientOrganismAntibioticSusceptibility.organism.id}`}>
                        {patientOrganismAntibioticSusceptibility.organism.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {patientOrganismAntibioticSusceptibility.antibiotic ? (
                      <Link to={`/antibiotic/${patientOrganismAntibioticSusceptibility.antibiotic.id}`}>
                        {patientOrganismAntibioticSusceptibility.antibiotic.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {patientOrganismAntibioticSusceptibility.sensitivity ? (
                      <Link to={`/clinical-dictionary/${patientOrganismAntibioticSusceptibility.sensitivity.id}`}>
                        {patientOrganismAntibioticSusceptibility.sensitivity.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/patient-organism-antibiotic-susceptibility/${patientOrganismAntibioticSusceptibility.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/patient-organism-antibiotic-susceptibility/${patientOrganismAntibioticSusceptibility.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/patient-organism-antibiotic-susceptibility/${patientOrganismAntibioticSusceptibility.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.patientOrganismAntibioticSusceptibility.home.notFound">
                No Patient Organism Antibiotic Susceptibilities found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div
          className={patientOrganismAntibioticSusceptibilityList && patientOrganismAntibioticSusceptibilityList.length > 0 ? '' : 'd-none'}
        >
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PatientOrganismAntibioticSusceptibility;
